export const organizationUpdateInterceptorFactory =
    ($window: ng.IWindowService) => {
      return {
        request: (config:ng.IRequestConfig):ng.IRequestConfig => {

          config.headers = config.headers || {};

          config.headers['Organization'] = $window.localStorage
            .getItem('currentOrgId');;

          return config;
        }
      };
    };

organizationUpdateInterceptorFactory.$inject = ['$window'];


/** WEBPACK FOOTER **
 ** ./app/auth/interceptor/organization-update.ts
 **/